import styled from 'styled-components';
import PropTypes from 'prop-types';
import { HEADER_HEIGHT } from 'conversations-visitor-experience-components/widget-dimensions/constants/dimensions';
import { UPDATED_VISITOR_WIDGET_BORDER_RADIUS } from 'conversations-visitor-experience-components/presentation-components/VisitorWidgetStyleWrapper';
const DragAndDropUploadOverlay = styled.div.withConfig({
  displayName: "DragAndDropUploadOverlay",
  componentId: "sc-26ijsy-0"
})(["position:absolute;width:100%;", ";transition:background 0.2s;z-index:99;border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;height:calc(100% - ", "px);display:flex;justify-content:center;align-items:center;pointer-events:none;"], ({
  isOver
}) => isOver && `background-color: rgba(45, 62, 80, 0.3);
  backdrop-filter: blur(2px);`, UPDATED_VISITOR_WIDGET_BORDER_RADIUS, UPDATED_VISITOR_WIDGET_BORDER_RADIUS, HEADER_HEIGHT);
DragAndDropUploadOverlay.displayName = 'DragAndDropUploadOverlay';
DragAndDropUploadOverlay.propTypes = {
  isOver: PropTypes.bool.isRequired
};
export default DragAndDropUploadOverlay;